import type { Shadows } from '@mui/material/styles';

export const lightShadows: Shadows = [
  'none',
  '0px 10px 20px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 25px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 30px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 35px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 40px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 45px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 50px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 55px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 60px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 65px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 70px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 70px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 70px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 70px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 75px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 75px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 75px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 75px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 80px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 80px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 80px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 80px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 80px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
  '0px 10px 80px 0px rgba(0, 90, 135, 0.15), 0px 0px 10px 0px rgba(0, 90, 135, 0.15)',
];

export const darkShadows: Shadows = [
  'none',
  '0px 10px 20px 0px rgba(100, 100, 100, 0.4), 0px 0px 5px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 25px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 30px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 35px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 40px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 45px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 50px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 55px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 60px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 65px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 70px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 70px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 70px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 70px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 75px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 75px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 75px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 75px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 80px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 80px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 80px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 80px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 80px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
  '0px 10px 80px 0px rgba(100, 100, 100, 0.4), 0px 0px 10px 0px rgba(100, 100, 100, 0.15)',
];
